import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const LinkCopiedIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 11",
    fill: "currentColor",
    width: size || '14',
    height: size || '11'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.59 9.782l.653.653 9.192-9.192-.979-.98-8.273 8.274L.919 5.273 0 6.193l3.59 3.59z",
    fillRule: "evenodd"
  }));
};
LinkCopiedIcon.displayName = 'LinkCopiedIcon';
export default LinkCopiedIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=LinkCopiedIcon.js.map